import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getCashPayments,
  cashPaymentListSuccessful,
  cashPaymentAddSuccessful,
  isModelVisible,
  getCashPaymentById,
  cashPaymentByIdSuccessful,
} from "./cashPaymentSlice";

import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";
import { axiosInstance } from "../../../helpers/AxiosHelper";
import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
} from "react-icons/ri";

function* CashPaymentGet({ payload }) {
  var data = payload;
  var params = {};
  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const response = yield call(getParamsList, "/payments/cash-payments/", params);
    yield put(cashPaymentListSuccessful({ response }));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddCashPayment({ payload }) {
  try {
    const { obj, profileObj } = payload;
    if (obj.id == 0) {
      const response = yield call(postAdd, "/payments/cash-payments/", obj);
      if (response.status === 201 || response.status === 200) {
        if (profileObj?.attachment && typeof profileObj.attachment !== 'string') {
          const formData = new FormData();
          formData.append('attachment', profileObj.attachment);
          yield call([axiosInstance, 'put'], "/payments/cash-payments/attachment/" + response.data.id, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        Modal.success({
          icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Cash Payment Added Successfully!</p></div>),
        });
        yield put(getCashPayments({ page: 1, search: "", page_size: 10 }));
        yield put(cashPaymentAddSuccessful());
      } else {
        Modal.error({
          icon: (<span className="remix-icon"><RiAlertLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Unable to add. Please try again!</p></div>),
        });
      }
    } else {
      const response = yield call(postEdit, "/payments/cash-payments/" + obj.id, obj);

      if (response.status === 200 || response.status === 201) {
        if (profileObj?.attachment && typeof profileObj.attachment !== 'string') {
          const formData = new FormData();
          formData.append('attachment', profileObj.attachment);
          yield call([axiosInstance, 'put'], "/payments/cash-payments/attachment/" + obj.id, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        }
        Modal.success({
          icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Cash Payment Updated Successfully!</p></div>),
        });
        yield put(getCashPayments({ page: 1, search: "", page_size: 10 }));
        yield put(cashPaymentAddSuccessful());
      } else {
        Modal.error({
          icon: (<span className="remix-icon"><RiAlertLine /></span>),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (<div><p className="hp-p1-body hp-text-color-black-80">Unable to update. Please try again!</p></div>),
        });
      }
    }
  } catch (error) {
    Modal.error({
      icon: (<span className="remix-icon"><RiAlertLine /></span>),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (<div><p className="hp-p1-body hp-text-color-black-80">Server side issue!</p></div>),
    });
    yield put(apiError(error));
  }
}

function* GetCashPaymentById({ payload }) {
  try {
    const response = yield call(getParamsList, "/payments/cash-payments/" + payload);
    yield put(cashPaymentByIdSuccessful(response));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* DeleteCashPayment({ payload }) {
  try {
    const response = yield call(postDelete, "/payments/cash-payments/" + payload);
    if (response.status === 204) {
      Modal.success({
        icon: (<span className="remix-icon"><RiCheckboxCircleLine /></span>),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Success</h5>,
        content: (<div><p className="hp-p1-body hp-text-color-black-80">Cash Payment deleted!</p></div>),
      });
      yield put(getCashPayments({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (<span className="remix-icon"><RiAlertLine /></span>),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (<div><p className="hp-p1-body hp-text-color-black-80">Unable to delete!</p></div>),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (<span className="remix-icon"><RiAlertLine /></span>),
      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (<div><p className="hp-p1-body hp-text-color-black-80">Server side issue!</p></div>),
    });
    yield put(apiError(error));
  }
}

export function* watchGetCashPayments() {
  yield takeEvery("cashPayment/getCashPayments", CashPaymentGet);
}
export function* watchCashPaymentAdd() {
  yield takeEvery("cashPayment/cashPaymentAdd", AddCashPayment);
}
export function* watchGetCashPaymentById() {
  yield takeEvery("cashPayment/getCashPaymentById", GetCashPaymentById);
}
export function* watchCashPaymentDelete() {
  yield takeEvery("cashPayment/cashPaymentDelete", DeleteCashPayment);
}

function* CashPaymentSaga() {
  yield all([
    fork(watchGetCashPayments),
    fork(watchCashPaymentAdd),
    fork(watchGetCashPaymentById),
    fork(watchCashPaymentDelete),
  ]);
}

export default CashPaymentSaga;
